import type {
    ComposableOptionsBase
} from '~/types';
import { LookupKeys, LookupHeaders } from '~/constants/lookup-keys';
import { unref } from 'vue';


export interface UseCmsApiUtilsOptions extends ComposableOptionsBase {}
export function useCmsApiUtils(options: Partial<UseCmsApiUtilsOptions> = {}) {
    const $config = useRuntimeConfig();
    const {
        appCommitHash,
        brand,
        baseURL,
        browserBaseURL
    } = $config.public;
    const siteId = brand.id;
    const {
        sessionIdKey,
        orgIdSessionKey,
    } = LookupKeys;
    const {
        siteIdHeader,
        siteContextHeader,
        siteVersionHeader,
        sessionIdHeader,
        orgIdHeader
    } = LookupHeaders;

    const baseAjaxHeaders = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    };

    function getCommonHeaders(obj: Record<string, string> = {}): Record<string, string>{

        const siteCurrentOrgUid = '';

        return {
            // Site ID / Site Version / Site Context
            [siteIdHeader]: `${siteId}`,
            [siteVersionHeader]: `${appCommitHash}`,
            [siteContextHeader]: unref(options.siteContext) ?? '',

            // Org ID / Org Membership Context
            [orgIdHeader]: siteCurrentOrgUid,

            // Other headers
            ...obj
        };
    }

    type CustomHeadersKeys = keyof typeof LookupHeaders;
    type CustomHeaders = Partial<Record<CustomHeadersKeys, string>>;

    function getCustomHeaders(
        customHeaders: Nilish<CustomHeaders> = {}
    ): Record<string, string> {
        const headers: Record<string, string> = {};

        if (customHeaders) {
            for (const [key, value] of Object.entries<any>(customHeaders)) {
                const hKey = LookupHeaders[(key as CustomHeadersKeys)];

                if (hKey) {
                    headers[hKey] = value;
                }
            }
        }

        return headers;
    }

    return {
        getCommonHeaders,
        getCustomHeaders,
        appCommitHash,
        brand,
        baseURL,
        browserBaseURL,
        sessionIdHeader,
        sessionIdKey,
        orgIdHeader,
        orgIdSessionKey,
        baseAjaxHeaders
    };
}
